import type { AuditEvent } from '@/types/portal';
import { imageUrl } from '@/utils/assets';

export const auditEvents: AuditEvent[] = [
  {
    id: 'aud-3001',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Invited a user',
    summary: 'invited Janet Kilonzo as Campaign Viewer',
    category: 'Access',
    resource: 'User',
    resourceId: 'janet@kilicreatives.co.ke',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'USR-INV-8821',
    timestamp: '2026-09-13 09:42',
    changes: [
      { field: 'Role', before: '—', after: 'Campaign Viewer' },
      { field: 'Market access', before: '—', after: 'Kenya' },
      { field: 'Status', before: '—', after: 'Invited' },
    ],
  },
  {
    id: 'aud-3002',
    actorId: 'usr-tom',
    actorName: 'Tom Otieno',
    actorAvatar: imageUrl('staff/staff-tom.webp'),
    actorRole: 'Finance User',
    action: 'Funded a wallet',
    summary: 'funded the KC Main funding wallet with KES 1,500,000',
    category: 'Money',
    resource: 'Wallet',
    resourceId: 'KC-MAIN (KES)',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.51',
    source: 'Web · Nairobi',
    reference: 'TOP-20419',
    timestamp: '2026-09-13 09:28',
    changes: [
      { field: 'Balance', before: 'KES 4,120,000', after: 'KES 5,620,000' },
      { field: 'Method', before: '—', after: 'Bank transfer · Equity' },
    ],
  },
  {
    id: 'aud-3003',
    actorId: 'usr-tom',
    actorName: 'Tom Otieno',
    actorAvatar: imageUrl('staff/staff-tom.webp'),
    actorRole: 'Finance User',
    action: 'Approved an invoice',
    summary: 'approved invoice INV-2299 for KES 480,000',
    category: 'Money',
    resource: 'Invoice',
    resourceId: 'INV-2299',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.51',
    source: 'Web · Nairobi',
    reference: 'INV-2299',
    timestamp: '2026-09-13 09:05',
    changes: [
      { field: 'Status', before: 'Pending review', after: 'Approved' },
      { field: 'Approved amount', before: '—', after: 'KES 480,000' },
    ],
  },
  {
    id: 'aud-3004',
    actorId: 'usr-moses',
    actorName: 'Moses Kamau',
    actorAvatar: imageUrl('staff/staff-moses.webp'),
    actorRole: 'Finance User',
    action: 'Retried a payout',
    summary: 'retried the failed payout to Brian Kiptoo (KES 96,000)',
    category: 'Money',
    resource: 'Payout',
    resourceId: 'PAY-77120',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.15.9',
    source: 'Web · Nairobi',
    reference: 'PAY-77120',
    timestamp: '2026-09-13 08:51',
    changes: [
      { field: 'Status', before: 'Payout failed', after: 'Processing' },
      { field: 'Rail', before: 'M-Pesa B2C', after: 'M-Pesa B2C' },
    ],
  },
  {
    id: 'aud-3005',
    actorId: 'usr-grace',
    actorName: 'Grace Achieng',
    actorAvatar: imageUrl('staff/staff-grace.webp'),
    actorRole: 'Creator Manager',
    action: 'Approved content',
    summary: 'approved the final deliverable from Claire Mwende on Zuri 5G Launch',
    category: 'Campaign',
    resource: 'Deliverable',
    resourceId: 'DEL-4410',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.22.130',
    source: 'Web · Nairobi',
    reference: 'DEL-4410',
    timestamp: '2026-09-13 08:33',
    changes: [
      { field: 'Status', before: 'Deliverable Submitted', after: 'Approved' },
    ],
  },
  {
    id: 'aud-3006',
    actorId: 'usr-samuel',
    actorName: 'Samuel Kimani',
    actorAvatar: imageUrl('staff/staff-samuel.webp'),
    actorRole: 'Campaign Viewer',
    action: 'Attempted to approve an invoice',
    summary: 'tried to approve invoice INV-2301 but was blocked',
    category: 'Money',
    resource: 'Invoice',
    resourceId: 'INV-2301',
    impact: 'Critical',
    outcome: 'Denied',
    market: 'Kenya',
    ip: '102.68.30.77',
    source: 'Web · Nakuru',
    reference: 'INV-2301',
    timestamp: '2026-09-13 08:12',
    changes: [
      { field: 'Reason', before: '—', after: 'Role lacks invoices.approve' },
    ],
  },
  {
    id: 'aud-3007',
    actorId: 'usr-kevin',
    actorName: 'Kevin Mutua',
    actorAvatar: imageUrl('staff/staff-kevin.webp'),
    actorRole: 'Creator Manager',
    action: 'Invited a creator',
    summary: 'invited Faith Njeri to join Zuri 5G Launch',
    category: 'Campaign',
    resource: 'Campaign',
    resourceId: 'Zuri 5G Launch',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Uganda',
    ip: '102.68.41.18',
    source: 'Web · Kampala',
    reference: 'CMP-4192',
    timestamp: '2026-09-13 07:58',
    changes: [
      { field: 'Campaign creators', before: '14', after: '15' },
    ],
  },
  {
    id: 'aud-3008',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Signed in',
    summary: 'signed in from a new device',
    category: 'Security',
    resource: 'Session',
    resourceId: 'peter.kironji@twiva.com',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi · Chrome',
    reference: 'SES-99015',
    timestamp: '2026-09-13 07:40',
    changes: [],
  },
  {
    id: 'aud-3009',
    actorId: 'usr-priya',
    actorName: 'Priya Shah',
    actorAvatar: imageUrl('staff/staff-priya.webp'),
    actorRole: 'Finance User',
    action: 'Sent a payment',
    summary: 'sent a single payment of KES 180,000 to Dennis Omondi',
    category: 'Money',
    resource: 'Payment',
    resourceId: 'PAY-55018',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.63',
    source: 'Web · Nairobi',
    reference: 'PAY-55018',
    timestamp: '2026-09-12 18:22',
    changes: [
      { field: 'Amount', before: '—', after: 'KES 180,000' },
      { field: 'Rail', before: '—', after: 'Bank transfer' },
    ],
  },
  {
    id: 'aud-3010',
    actorId: 'usr-fatuma',
    actorName: 'Fatuma Ali',
    actorAvatar: imageUrl('staff/staff-fatuma.webp'),
    actorRole: 'Creator Manager',
    action: 'Created a campaign',
    summary: 'created the campaign Halisi Festive Season',
    category: 'Campaign',
    resource: 'Campaign',
    resourceId: 'Halisi Festive Season',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.22.144',
    source: 'Web · Nairobi',
    reference: 'CMP-4201',
    timestamp: '2026-09-12 17:04',
    changes: [
      { field: 'Budget', before: '—', after: 'KES 2,400,000' },
      { field: 'Status', before: '—', after: 'Draft' },
    ],
  },
  {
    id: 'aud-3011',
    actorId: 'usr-tom',
    actorName: 'Tom Otieno',
    actorAvatar: imageUrl('staff/staff-tom.webp'),
    actorRole: 'Finance User',
    action: 'Exported the ledger',
    summary: 'exported 214 transactions as CSV',
    category: 'Money',
    resource: 'Export',
    resourceId: 'transactions.csv',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.51',
    source: 'Web · Nairobi',
    reference: 'EXP-3388',
    timestamp: '2026-09-12 16:30',
    changes: [
      { field: 'Rows', before: '—', after: '214' },
      { field: 'Filter', before: '—', after: 'Last 30 days · All wallets' },
    ],
  },
  {
    id: 'aud-3012',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Changed role permissions',
    summary: 'granted discovery.export to the Creator Manager role',
    category: 'Access',
    resource: 'Role',
    resourceId: 'Creator Manager',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'ROL-1120',
    timestamp: '2026-09-12 15:47',
    changes: [
      { field: 'discovery.export', before: 'Not granted', after: 'Granted' },
      { field: 'Permissions', before: '12', after: '13' },
    ],
  },
  {
    id: 'aud-3013',
    actorId: 'usr-wanjiku',
    actorName: 'Wanjiku Njoroge',
    actorAvatar: imageUrl('staff/staff-wanjiku.webp'),
    actorRole: 'Creator Manager',
    action: 'Shortlisted creators',
    summary: 'shortlisted 6 creators into the list Beauty Q4 Kenya',
    category: 'Campaign',
    resource: 'Saved list',
    resourceId: 'Beauty Q4 Kenya',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.22.101',
    source: 'Web · Nairobi',
    reference: 'LST-2204',
    timestamp: '2026-09-12 14:12',
    changes: [
      { field: 'List size', before: '9', after: '15' },
    ],
  },
  {
    id: 'aud-3014',
    actorId: 'usr-moses',
    actorName: 'Moses Kamau',
    actorAvatar: imageUrl('staff/staff-moses.webp'),
    actorRole: 'Finance User',
    action: 'Froze a wallet',
    summary: "froze Jabari Otieno's creator wallet",
    category: 'Money',
    resource: 'Wallet',
    resourceId: 'Jabari Otieno (KES)',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.15.9',
    source: 'Web · Nairobi',
    reference: 'WAL-7730',
    timestamp: '2026-09-12 12:35',
    changes: [
      { field: 'Status', before: 'Wallet active', after: 'Wallet frozen' },
      { field: 'Balance held', before: '—', after: 'KES 62,400' },
    ],
  },
  {
    id: 'aud-3015',
    actorId: 'usr-grace',
    actorName: 'Grace Achieng',
    actorAvatar: imageUrl('staff/staff-grace.webp'),
    actorRole: 'Creator Manager',
    action: 'Contracted a creator',
    summary: 'issued a contract to Faith Njeri for KES 420,000',
    category: 'Campaign',
    resource: 'Contract',
    resourceId: 'CTR-6612',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.22.130',
    source: 'Web · Nairobi',
    reference: 'CTR-6612',
    timestamp: '2026-09-12 11:20',
    changes: [
      { field: 'Status', before: 'Contract Pending', after: 'Contracted' },
    ],
  },
  {
    id: 'aud-3016',
    actorId: 'usr-priya',
    actorName: 'Priya Shah',
    actorAvatar: imageUrl('staff/staff-priya.webp'),
    actorRole: 'Finance User',
    action: 'Failed to upload a batch',
    summary: 'uploaded a payment batch but 1 row was rejected',
    category: 'Money',
    resource: 'Payment batch',
    resourceId: 'BAT-UPLOAD',
    impact: 'Standard',
    outcome: 'Failed',
    market: 'Kenya',
    ip: '102.68.14.63',
    source: 'Web · Nairobi',
    reference: 'BAT-9940',
    timestamp: '2026-09-12 10:05',
    changes: [
      { field: 'Rows accepted', before: '—', after: '13 of 14' },
      { field: 'Reason', before: '—', after: 'Row 14: wallet inactive' },
    ],
  },
  {
    id: 'aud-3017',
    actorId: 'usr-kevin',
    actorName: 'Kevin Mutua',
    actorAvatar: imageUrl('staff/staff-kevin.webp'),
    actorRole: 'Creator Manager',
    action: 'Signed in',
    summary: 'signed in',
    category: 'Security',
    resource: 'Session',
    resourceId: 'kevin@kilicreatives.co.ke',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Uganda',
    ip: '102.68.41.18',
    source: 'Web · Kampala · Chrome',
    reference: 'SES-98990',
    timestamp: '2026-09-12 09:18',
    changes: [],
  },
  {
    id: 'aud-3018',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Deactivated a user',
    summary: 'deactivated Peter Ochieng and signed them out everywhere',
    category: 'Access',
    resource: 'User',
    resourceId: 'peter@kilicreatives.co.ke',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'USR-8802',
    timestamp: '2026-09-11 19:40',
    changes: [
      { field: 'Status', before: 'Active', after: 'Deactivated' },
      { field: 'Sessions', before: '2', after: 'Revoked' },
    ],
  },
  {
    id: 'aud-3019',
    actorId: 'usr-tom',
    actorName: 'Tom Otieno',
    actorAvatar: imageUrl('staff/staff-tom.webp'),
    actorRole: 'Finance User',
    action: 'Approved a payment batch',
    summary: 'approved batch BAT-9932 totalling KES 3,240,000',
    category: 'Money',
    resource: 'Payment batch',
    resourceId: 'BAT-9932',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.51',
    source: 'Web · Nairobi',
    reference: 'BAT-9932',
    timestamp: '2026-09-11 17:55',
    changes: [
      { field: 'Status', before: 'Pending approval', after: 'Approved' },
      { field: 'Lines', before: '18', after: '18' },
    ],
  },
  {
    id: 'aud-3020',
    actorId: 'usr-halisi',
    actorName: 'Halisi Foods',
    actorAvatar: imageUrl('staff/staff-halisi.webp'),
    actorRole: 'Client User',
    action: 'Signed in',
    summary: 'signed in to review campaign performance',
    category: 'Security',
    resource: 'Session',
    resourceId: 'marketing@halisifoods.co.ke',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Kenya',
    ip: '41.90.64.12',
    source: 'Web · Nairobi · Safari',
    reference: 'SES-98955',
    timestamp: '2026-09-11 16:10',
    changes: [],
  },
  {
    id: 'aud-3021',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Changed brand colour',
    summary: 'updated the primary brand colour on the portal',
    category: 'Config',
    resource: 'Branding',
    resourceId: 'primary',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'BRD-4410',
    timestamp: '2026-09-11 15:02',
    changes: [
      { field: 'Primary', before: '#B3542E', after: '#9C4A2B' },
    ],
  },
  {
    id: 'aud-3022',
    actorId: 'usr-priya',
    actorName: 'Priya Shah',
    actorAvatar: imageUrl('staff/staff-priya.webp'),
    actorRole: 'Finance User',
    action: 'Rejected an invoice',
    summary: 'rejected invoice INV-2287 for KES 132,000',
    category: 'Money',
    resource: 'Invoice',
    resourceId: 'INV-2287',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Tanzania',
    ip: '102.68.14.63',
    source: 'Web · Nairobi',
    reference: 'INV-2287',
    timestamp: '2026-09-11 13:48',
    changes: [
      { field: 'Status', before: 'Pending review', after: 'Rejected' },
      { field: 'Reason', before: '—', after: 'Rate mismatch on line 2' },
    ],
  },
  {
    id: 'aud-3023',
    actorId: 'usr-grace',
    actorName: 'Grace Achieng',
    actorAvatar: imageUrl('staff/staff-grace.webp'),
    actorRole: 'Creator Manager',
    action: 'Requested a KYC re-check',
    summary: 'flagged creator Esther Njoki for a KYC re-check',
    category: 'Campaign',
    resource: 'Creator',
    resourceId: 'Esther Njoki',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.22.130',
    source: 'Web · Nairobi',
    reference: 'CRT-7741',
    timestamp: '2026-09-11 11:30',
    changes: [
      { field: 'KYC status', before: 'KYC complete', after: 'Pending review' },
    ],
  },
  {
    id: 'aud-3024',
    actorId: 'usr-samuel',
    actorName: 'Samuel Kimani',
    actorAvatar: imageUrl('staff/staff-samuel.webp'),
    actorRole: 'Campaign Viewer',
    action: 'Attempted to export a report',
    summary: 'tried to export the Spend report but was blocked',
    category: 'Config',
    resource: 'Report',
    resourceId: 'spend-report.csv',
    impact: 'Sensitive',
    outcome: 'Denied',
    market: 'Kenya',
    ip: '102.68.30.77',
    source: 'Web · Nakuru',
    reference: 'EXP-3390',
    timestamp: '2026-09-11 10:14',
    changes: [
      { field: 'Reason', before: '—', after: 'Role lacks reports.export' },
    ],
  },
  {
    id: 'aud-3025',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Verified the client domain',
    summary: 'verified portal.kilicreatives.co.ke and enabled HTTPS',
    category: 'Config',
    resource: 'Domain',
    resourceId: 'portal.kilicreatives.co.ke',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'DOM-2201',
    timestamp: '2026-09-10 18:20',
    changes: [
      { field: 'Domain status', before: 'Pending', after: 'Verified' },
      { field: 'HTTPS', before: 'Off', after: 'On' },
    ],
  },
  {
    id: 'aud-3026',
    actorId: 'usr-tom',
    actorName: 'Tom Otieno',
    actorAvatar: imageUrl('staff/staff-tom.webp'),
    actorRole: 'Finance User',
    action: 'Connected an integration',
    summary: 'connected the Flutterwave payout rail',
    category: 'Config',
    resource: 'Integration',
    resourceId: 'Flutterwave',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.51',
    source: 'Web · Nairobi',
    reference: 'INT-5510',
    timestamp: '2026-09-10 16:45',
    changes: [
      { field: 'Status', before: 'Not connected', after: 'Connected' },
    ],
  },
  {
    id: 'aud-3027',
    actorId: 'usr-kevin',
    actorName: 'Kevin Mutua',
    actorAvatar: imageUrl('staff/staff-kevin.webp'),
    actorRole: 'Creator Manager',
    action: 'Closed a campaign',
    summary: 'closed the campaign Jumia Back-to-School',
    category: 'Campaign',
    resource: 'Campaign',
    resourceId: 'Jumia Back-to-School',
    impact: 'Sensitive',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.41.18',
    source: 'Web · Nairobi',
    reference: 'CMP-4110',
    timestamp: '2026-09-10 14:33',
    changes: [
      { field: 'Status', before: 'Recruiting', after: 'Archived' },
    ],
  },
  {
    id: 'aud-3028',
    actorId: 'usr-moses',
    actorName: 'Moses Kamau',
    actorAvatar: imageUrl('staff/staff-moses.webp'),
    actorRole: 'Finance User',
    action: 'Scheduled a payout',
    summary: 'scheduled a payout of KES 245,000 to Achieng Odhiambo',
    category: 'Money',
    resource: 'Payout',
    resourceId: 'PAY-77142',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.15.9',
    source: 'Web · Nairobi',
    reference: 'PAY-77142',
    timestamp: '2026-09-10 12:11',
    changes: [
      { field: 'Amount', before: '—', after: 'KES 245,000' },
      { field: 'Scheduled', before: '—', after: '14 Sep 2026' },
    ],
  },
  {
    id: 'aud-3029',
    actorId: 'usr-amina',
    actorName: 'Peter Kironji',
    actorAvatar: imageUrl('staff/staff-amina.webp'),
    actorRole: 'Agency Administrator',
    action: 'Created a role',
    summary: 'created the custom role Regional Lead',
    category: 'Access',
    resource: 'Role',
    resourceId: 'Regional Lead',
    impact: 'Critical',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.22',
    source: 'Web · Nairobi',
    reference: 'ROL-1124',
    timestamp: '2026-09-10 10:52',
    changes: [
      { field: 'Cloned from', before: '—', after: 'Creator Manager' },
      { field: 'Ceiling', before: '—', after: 'KES 500,000' },
    ],
  },
  {
    id: 'aud-3030',
    actorId: 'usr-priya',
    actorName: 'Priya Shah',
    actorAvatar: imageUrl('staff/staff-priya.webp'),
    actorRole: 'Finance User',
    action: 'Signed in',
    summary: 'signed in',
    category: 'Security',
    resource: 'Session',
    resourceId: 'priya@kilicreatives.co.ke',
    impact: 'Standard',
    outcome: 'Success',
    market: 'Kenya',
    ip: '102.68.14.63',
    source: 'Web · Nairobi · Chrome',
    reference: 'SES-98870',
    timestamp: '2026-09-10 09:07',
    changes: [],
  },
];

export const auditCategories = ['All', 'Money', 'Access', 'Campaign', 'Config', 'Security'] as const;

export const auditImpacts = ['All impacts', 'Standard', 'Sensitive', 'Critical'] as const;